// Update these values after deployment
export const config = {
  userPoolId: process.env.REACT_APP_USER_POOL_ID || "YOUR_USER_POOL_ID",
  clientId: process.env.REACT_APP_CLIENT_ID || "YOUR_CLIENT_ID",
  apiUrl: process.env.REACT_APP_API_URL || "YOUR_API_URL",
  region: process.env.REACT_APP_REGION || "us-east-1",
  oauthDomain: process.env.REACT_APP_OAUTH_DOMAIN || "YOUR_OAUTH_DOMAIN",
  identityProvider: process.env.REACT_APP_IDENTITY_PROVIDER || "Midway",
};
